import {QueryKey, useQuery, UseQueryOptions} from '@tanstack/react-query';
import {getMarkets} from 'api/requests';
import {IMarketsRequest, IMarketsResponse} from 'types';

export const useMarkets = (queryKey: QueryKey, options: UseQueryOptions<IMarketsResponse>, query: IMarketsRequest) => {
  const newSlug = query.categorySlug ? (query.categorySlug == '18 ' ? '18+' : query.categorySlug) : undefined;

  return useQuery<IMarketsResponse>({
    queryKey,
    queryFn: () => getMarkets(newSlug ? {...query, categorySlug: newSlug} : query),
    ...options,
  });
};
